import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home';
import Login from '@/views/Login';
import LoginHelp from '@/views/LoginHelp';
import Signup from '@/views/Signup';
import PageNotFound from '@/views/PageNotFound';
import ProfilesGate from '@/views/profiles/ProfilesGate/ProfilesGate';
import ManageProfiles from '@/views/profiles/ManageProfiles/ManageProfiles';
import Logout from '@/views/Logout';
import YourAccount from '@/views/YourAccount/YourAccount';
import LanguageSetup from '@/views/profiles/LanguageSetup/LanguageSetup';
import Movies from '@/views/NewMovies/NewMovies';
import AllMovies from '@/views/Movies/Movies';
import TVGuide from '@/views/TVGuide/TVGuide';
import MyList from '@/views/MyList';
import SportsVOD from '@/views/SportsVOD';
import ComingSoon from '@/views/ComingSoon';
import Search from '@/views/Search/Search';
import TVShows from '@/views/TVShows';
import PlayerWrap from '@/views/Player/PlayerWrap';
import LiveTv from '@/views/LiveTv/LiveTv';
import { getItem, removeItem, setItem } from '@/helpers/storage';

const PUBLIC_META = { public: true };
const AUTH_META = { requiresAuth: true };
const GUEST_LINK_META = { requiresAuth: false, public: true };

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: PUBLIC_META,
  },
  {
    path: '/sports',
    name: 'SportsVOD',
    component: SportsVOD,
    props: { pageName: 'sportsVOD' },
    meta: AUTH_META,
  },
  {
    path: '/installation',
    name: 'Install Application',
    component: ComingSoon,
    props: { pageName: 'installation' },
    meta: AUTH_META,
  },
  {
    path: '/livetv',
    name: 'LiveTv',
    component: LiveTv,
    meta: AUTH_META,
  },
  {
    path: '/tvshows',
    name: 'TVShows',
    component: TVShows,
    props: { pageName: 'TvShows' },
    meta: AUTH_META,
  },
  {
    path: '/tvguide',
    name: 'TVGuide',
    component: TVGuide,
    meta: AUTH_META,
  },
  {
    path: '/video',
    name: 'Video',
    component: PlayerWrap,
    meta: AUTH_META,
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: AUTH_META,
  },
  {
    path: '/mylist',
    name: 'MyList',
    component: MyList,
    meta: AUTH_META,
  },
  {
    path: '/',
    name: 'Sign In',
    component: Login,
    meta: PUBLIC_META,
  },
  {
    path: '/loginguid/:username/:guid',
    name: 'loginguid',
    component: Login,
    meta: GUEST_LINK_META,
  },
  {
    path: '/loginTrial/:lead/:guid',
    name: 'loginTrial',
    component: Login,
    meta: GUEST_LINK_META,
  },
  {
    path: '/watchlinklogin/:token',
    name: 'watchlinklogin',
    component: Login,
    meta: GUEST_LINK_META,
  },
  {
    path: '/p/:serial',
    name: 'shortLink',
    component: Login,
    meta: GUEST_LINK_META,
  },
  {
    path: '/loginHelp',
    name: 'Login Help',
    component: LoginHelp,
    meta: PUBLIC_META,
  },
  {
    path: '/Signup',
    name: 'Sign Up',
    component: Signup,
    meta: PUBLIC_META,
  },
  {
    path: '/profiles',
    name: 'profiles',
    children: [
      {
        path: 'manage',
        name: 'ManageProfiles',
        component: ManageProfiles,
      },
      {
        path: 'languagesetup',
        name: 'LanguageSetup',
        component: LanguageSetup,
      },
    ],
    meta: AUTH_META,
  },
  {
    path: '/ProfilesGate',
    name: 'ProfilesGate',
    component: ProfilesGate,
    meta: AUTH_META,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: AUTH_META,
  },
  {
    path: '/allMovies',
    name: 'All Movies',
    component: AllMovies,
    meta: AUTH_META,
  },
  {
    path: '/movies',
    name: 'Movies',
    component: Movies,
    meta: AUTH_META,
  },
  {
    path: '/YourAccount',
    name: 'YourAccount',
    component: YourAccount,
    meta: AUTH_META,
  },
  {
    path: '/:catchAll(.*)',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: PUBLIC_META,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

let isFirstNavigation = true;

router.beforeEach((to) => {
  if (to.path !== '/video') {
    removeItem('content-info');
  }

  const hasAccessToken = Boolean(getItem('accessToken'));

  if (isFirstNavigation) {
    if (!hasAccessToken) setItem('savedPath', to.fullPath);
    isFirstNavigation = false;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    return hasAccessToken || '/';
  }

  if (to.matched.some((record) => record.meta.public)) {
    return !hasAccessToken || '/movies';
  }

  return true;
});

export default router;
